import { IPlaceCategory } from 'capability-ng-resources';
import {
  IResourceDetail,
  ResourceCategoryQuery,
  ResourceListServant,
  ResourceSearchQuery,
  ResourceSearchModel
} from 'capability-ng-resources';
import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';

export class MyPlacesListController {
  private placeCategoryList: IPlaceCategory[];
  private activeCategory: IPlaceCategory;
  private resourceList: IResourceDetail[];
  private searchPlaces: () => void;
  private isSearching: boolean = !_4.isEmpty(this.searchTerm);

  constructor(
    private $state: ng.ui.IStateService,
    private ngResourceCategoryQuery: ResourceCategoryQuery,
    private ngResourceListServant: ResourceListServant,
    private loadResourcesCommand: ICommand,
    private ngResourceSearchModel: ResourceSearchModel,
    private ngResourceSearchQuery: ResourceSearchQuery,
    private $stateParams: ng.ui.IStateParamsService
  ) {
    this.resourceList = [];
    this.placeCategoryList = ngResourceCategoryQuery.result;
    if (this.hasCategories()) {
      this.activeCategory = _4.isEmpty(this.$stateParams.activeCategory)
        ? _4.first(this.placeCategoryList)
        : this.$stateParams.activeCategory;
    }
    this.loadResourcesCommand().then(() => {
      this.setActiveCategory(this.activeCategory);
    });
  }

  $onInit(): void {
    this.searchPlaces = this.search.bind(this);
  }

  hasCategories(): boolean {
    return !_4.isEmpty(this.placeCategoryList);
  }

  updateActiveCategory(event: JQueryEventObject): void {
    const category = _4.get(event, 'detail.value', this.activeCategory);
    if (!_4.isEmpty(category)) {
      this.setActiveCategory(category);
    }
  }

  setActiveCategory(category: IPlaceCategory): void {
    this.activeCategory = category;
    this.$state.params.activeCategory = category;
    this.resourceList = this.ngResourceListServant.getResourceForCategory(category.id);
  }

  goToResource(resource: IResourceDetail) {
    this.$state.go('my.resourcesDetail', {
      id: resource.id
    });
  }

  isActiveCategory(category: IPlaceCategory): boolean {
    return _4.isEmpty(this.activeCategory) ? false : category.id === this.activeCategory.id;
  }

  hasResources(): boolean {
    return !_4.isEmpty(this.resourceList);
  }

  search(term: string) {
    this.isSearching = !_4.isEmpty(term);
    this.ngResourceSearchModel.write({ searchTerm: term });
    this.ngResourceSearchQuery.run();
  }

  hasSearchResults(): boolean {
    return !_4.isEmpty(this.ngResourceSearchQuery.result);
  }

  get searchTerm(): string {
    const { searchTerm } = this.ngResourceSearchModel.read();
    return searchTerm;
  }
}



// WEBPACK FOOTER //
// ./app/lib/my_resources/views/my_places_list/my_places_list.ts